<ion-modal #modalStory
    class="modal_story" 
    [canDismiss]="this.canDismissStoryModal.bind(this)"
    (didDismiss)="this.onDidDismissStoryModal($event)"       
    >
    <ng-template>        
        <ion-content>
            <div class="modal_story_content">
                <div class="btn_close_modal">
                    <ion-icon name="close-outline" (click)="this.dismiss()"></ion-icon>
                </div>
                
                <div class="stories_progress_container">
                    @for(story of this.stories; track $index){
                        <div class="story_progress" [class.current_story]="this.indexVideo === $index">
                            <div class="story_progress_value" [style.width]="this.tabProgressValues[$index]+'%'"></div>
                        </div>
                    }
                </div>
                
                <div class="stories_container_video">
                    
                    @if(this.isFetchingStory){
                        <div class="bloc_loading">
                            <ion-spinner></ion-spinner>
                        </div> 
                    }
                    
                    <video #storyVideoPlayer autoplay="true" playsinline="true" webkit-playsinline="true">
                        <source type="video/mp4"/>
                    </video>
                </div>
                
                <div class="btn_previous_story" (click)="this.previousStoryVideo()"></div>
                <div class="btn_next_story" (click)="this.nextStoryVideo()"></div>
                
            </div>
        </ion-content>
    </ng-template>
</ion-modal>